import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = 'ACCEDER AL SISTEMA AHORA',
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.a href="#plan-selection" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={e => {
    e.preventDefault();
    document.getElementById('plan-selection')?.scrollIntoView({
      behavior: 'smooth'
    });
    onClick?.();
  }} className={`
        inline-flex items-center justify-center
        bg-[#22C55E] hover:bg-[#16a34a] 
        text-white font-bold text-lg md:text-xl
        py-4 px-8 rounded-full
        shadow-[0_0_20px_rgba(34,197,94,0.4)]
        hover:shadow-[0_0_30px_rgba(34,197,94,0.6)]
        transition-all duration-300
        text-center
        ${className}
      `} data-id="element-430">
      <span className="uppercase tracking-wide" data-id="element-431">{text}</span>
      <svg className="w-5 h-5 ml-2" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-432">
        <path d="M4 10h12m0 0l-4-4m4 4l-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-433" />
      </svg>
    </motion.a>;
}